<template>
    <div class="type_of_deposit_parent">
        <div class="choose_payment_title_h">
            <button type="button thm-btn" @click="$router.go(-1)" class="back_btn_cl_deposit">
            <i class="fa-solid fa-angle-left"></i>
            <!-- {{ $t('back', 'Back') }} -->
        </button>
        <h3>{{ $t('Choose-payment-method', 'Choose A Payment Method') }}</h3>
        </div>
        <div class="description-card-body payment_type_tabs_cl">
            <div class="row">
                <div class="col-12">
                    <div class="deposit_tabs_cl">
                        <ul  class="nav nav-tabs" id="myTab" role="tablist">
                            <li v-for="(method, index) in parentPaymentsList" :key="index" class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: activeTab === index, paymentBonus: paymentBonus?.[method?.[0]?.method_id] }" @click="choosePaymentMethod(method, index)" data-bs-toggle="tab" data-bs-target="#tab" id="tabId" role="tab" type="button" aria-controls="tab"
                                :aria-selected="activeTab === index">
                                    <div class="get-bonus-sec" v-if="paymentBonus?.[method?.[0]?.method_id]">Get {{ paymentBonus?.[method?.[0]?.method_id] }}% Bonus</div>
                                    <span>{{ index }}</span>
                                    <img loading="lazy" :src="methodIcons[index]" />
                                </button>
                            </li>
                        </ul>
                        <span v-if="paymentDetailsList?.[0]?.method == 'bank'">You can add through a bank transfer</span>
                    </div>
                </div>
            </div>
        </div>
        <div  class="description-card-body payment_type_tabs_content_cl">
            <div class="withdraw-sec add-account-sec mt-0 p-2" v-if="isPaymentGateway && paymentDetailsList?.[0]?.method != 'social'">
                <div class="hide-input-sec depo-payment-gateway-sec">
                    <div>
                        Pay using our payemnt gateway
                    </div>
                    <div class="matka-but-dflex pg-btn">
                        <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="myTabContent" v-if="parentPaymentsList && !isPaymentGateway && paymentDetailsList?.[0]?.method != 'social'">
                <div class="tab-pane fade show active" id="tab" role="tabpanel" aria-labelledby="tabId">
                    <div class="depo-lft-container imps_deposit_sec imps_tabs_content">
                            <div class="description-card-body account_data_parent m-0 pt-0">
                                <div class="row">
                                    <div class="col-12">
                                        <!-- <div class="about-text">
                                            <h5 class="card_title_cl">{{ method.name }}</h5>
                                        </div> -->
                                        <div class="multile_select_wrapper deposit-bank-added-list">
                                            <div class="account-data" :class="{ 'selected-card' : accountDetails?.master_account_id === bank?.master_account_id }"
                                                v-for="(bank, index) in paymentDetailsList" :key="index" @click="selectPaymentMethodAccount(bank)">
                                                <div class="card-text" v-if="bank?.bank_name">
                                                    <div class="account_title_list">
                                                        <span>{{ $t('bank-name', 'Bank Name') }}</span> 
                                                        <span>:</span>
                                                        <span class="bank_val_123">{{ bank?.bank_name }}</span>
                                                    </div>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($t('bank-name', 'Bank Name'), bank?.bank_name,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span></div> -->
                                                    </button>
                                                </div>
                                                 <div class="card-text" v-if="bank?.account_number"> 
                                                    <div class="account_title_list">
                                                        <span>{{ $t('account-number', 'Account Number') }}</span>
                                                        <span>:</span>
                                                        <span class="bank_val_123">{{ bank?.account_number  }}</span>
                                                    </div>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($t('account-number', 'Account Number'), bank.account_number ,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                    </button>
                                                </div>
                                                <div class="card-text">
                                                    <div class="account_title_list">
                                                        <span>{{ bank?.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}</span>
                                                        <span>:</span>
                                                    <span class="bank_val_123">{{ bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id) }}</span>
                                                    </div>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData(bank.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID'), bank.account_number ? bank.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                    </button>
                                                </div>
                                                <div class="card-text"> 
                                                    <div class="account_title_list">
                                                        <span>{{ $t('account-holder-name', ' Name') }}</span> 
                                                        <span>:</span>
                                                    <span>{{ bank?.account_holder_name }}</span>
                                                    </div>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($t('account-holder-name', 'Account holder’s name'), bank?.account_holder_name,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                    </button>
                                                </div>
                                                <div class="card-text" v-if="bank?.crypto_wallet_id"> 
                                                    <div class="account_title_list">
                                                        <span>Deposit Amount</span> 
                                                        <span>:</span>
                                                        <span>
                                                            {{ (depositAmount/bank?.multiplier_value)?.toFixed(2) }} {{ bank?.method_name}}
                                                                <span>( at x{{ Number(bank?.multiplier_value) }} )</span>
                                                        </span>
                                                    </div>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($event,'Deposit Amount', (depositAmount/bank?.multiplier_value),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                </div>
                                                <!-- <p class="card-text"> {{ $t('min-amount', 'Min Amount') }} : {{ bank?.min_range }} </p>
                                                <p class="card-text"> {{ $t('max-amount', 'Max Amount') }} : {{ bank?.max_range }} </p> -->
                                                <div class="qr_scaner_sec" v-if="bank?.qr_code">
                                                    <figure>
                                                        <img :src="bank?.qr_code" alt="QR-Code">
                                                    </figure>
                                                    <div class="qr-btn-group">
                                                        <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrPreviewModal" @click="qrCode = (bank?.qr_code)">
                                                            <img src="@/assets/images/qr-full-screen.svg" alt="full_screen" />
                                                        </button>
                                                        <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrShareModal" @click="qrCode = (bank.qr_code)">
                                                            <img src="@/assets/images/qr-share.svg" alt="qr-share" />
                                                        </button>
                                                        <button class="qr-btn" @click="downloadQrImg(bank.qr_code, bank?.account_holder_name)">
                                                            <img src="@/assets/images/qr-downloads.svg" alt="at-download" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div class="utr_proof_cl">
                            <div class="bet_body box_shadow payment_opiton enter_amount">
                                <div class="form-group utr_file_input_grp" v-if="!previewImage">
                                    <label for="proofOfDeposit220225">
                                        {{ $t('upload-your-payment-proof', 'Upload Your Payment Proof') }}
                                        <small style="color: red;">[{{ $t('required', 'Required') }}]</small>
                                    </label>
                                    <input type="file" ref="fileRef" @click="onFilePickerOpen" class="form-control" @change="fileUpdateFunc" accept=".png, .jpg, .jpeg, .webp"/>
                                    <label class="error_cl" v-if="init.transaction_image_url && !uploadedImage" >
                                        {{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}.</label>
                                </div>
                                <div class="number-header col-12 thm-heading d-inline-block" v-if="previewImage">
                                    <h5 class="mb-2 info-sec team-list-wet">{{ $t('payment-slip', 'Payment Slip') }}</h5>
                                    <div class="fileList"><img class="fileList-img" :src="previewImage" alt="file-list"/><button
                                            class="add-utr-again p-2" @click="clearPaymentSlip()">
                                            <img src="@/assets/images/cross-icon.webp" alt="cross-icon" loading="lazy">
                                        </button>
                                        <div class="fileList-loader" v-if="utrLoader">
                                            <div class="loader">
                                                <div class="sk-fading-circle">
                                                    <div class="sk-circle1 sk-circle"></div>
                                                    <div class="sk-circle2 sk-circle"></div>
                                                    <div class="sk-circle3 sk-circle"></div>
                                                    <div class="sk-circle4 sk-circle"></div>
                                                    <div class="sk-circle5 sk-circle"></div>
                                                    <div class="sk-circle6 sk-circle"></div>
                                                    <div class="sk-circle7 sk-circle"></div>
                                                    <div class="sk-circle8 sk-circle"></div>
                                                    <div class="sk-circle9 sk-circle"></div>
                                                    <div class="sk-circle10 sk-circle"></div>
                                                    <div class="sk-circle11 sk-circle"></div>
                                                    <div class="sk-circle12 sk-circle"></div>
                                                </div>
                                            </div>
                                            <span class="count_down_timer"> {{ timerValue }}</span>
                                        </div>
                                    </div>
                                    <div class="paymentProofFileUploadStatus"v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>
                                </div>
                            </div>
                            <div v-if="!loading" class="bet_body box_shadow payment_opiton enter_amount">
                                <div class="form-group">
                                    <label for="transactionId" class="trans_Id">
                                        {{ $t('unique-transaction-reference', 'Unique Transaction Reference') }} 
                                        <small style="color: red;" v-if="accountDetails?.method != 'wallet'">*</small>
                                    </label>
                                    <input type="tel" :maxlength="accountDetails?.method != 'wallet' ? 15 : 128" class="form-control utr_input_cl" v-model="manual_utr" @input="sanitizeInput(), has_edited_utr = 1" :placeholder="$t('enter-utr-number', 'Enter UTR number')" />
                                    <label v-if="accountDetails?.method != 'wallet' && init.utr && !manual_utr?.length" class="error" for="transactionId">Please Enter UTR Number</label>
                                    <label v-else-if="accountDetails?.method != 'wallet' && init.utr && manual_utr?.length < 10" class="error" for="transactionId">{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</label>
                                </div>
                            </div>
                            <!-- <div v-if="utrLoader" class="bet_body box_shadow payment_opiton enter_amount wallet_loading_box">
                                <div class="utr-loader">
                                    <div class="loader">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div> -->

                            <div class="form-group amount_deposit_input">
                                <label for="exampleFormControlInput1">
                                    {{ $t('amount', 'Amount') }} <small style="color: red;">*</small>
                                </label>
                                <input type="number" class="form-control" v-model="depositAmount" readonly />
                            </div>

                            <div class="custom-control custom_checkbox_cl">
                                <input type="checkbox" class="form-check-input custom-control-input" v-model="termsAgreed" />
                                <label class="custom-control-label text-capitalize">
                                    {{ $t('i-have-read-and-agree-with', 'I have read and agree with') }}
                                    <a href="#termsAndCondition" data-bs-toggle="modal" class="terms_condition_cl">
                                        {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}.
                                    </a>
                                </label>
                            </div>

                            <div class="wallet-deposit-cmn-btn login-option-btn position-relative">
                                <button type="button" @click="walletDepositSubmitBtn()" class="withdrawBtn submit_form_cl">
                                    <template v-if="!loadingSubmit">
                                        {{ $t('submit', 'Submit') }} <span><b></b><b></b><b></b></span>
                                    </template>
                                    <div v-if="loadingSubmit" class="spinner-border login_loader" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="type_of_deposit_parent p-0">
            <WalletInstructions instructionType="deposit" />
        </div>
        <div class="withdraw_pass_modal withdraw_policy_modal">
            <div class="modal fade" id="termsAndCondition" tabindex="-1" aria-labelledby="termsAndConditionModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="termsAndCondition">
                                {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}
                            </h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <p>Limits The maximum deposit limit on your account will vary depending on how long you have been a customer with us and whether you have successfully passed our security checks. <span v-if="$siteSettings?.data?.social_link?.email">Please contact the <a :href="`mailto:${$siteSettings?.data?.social_link?.email}`">{{$siteSettings?.data?.social_link?.email}}</a> for further information</span></p>
                            <p>Security Please note you may be asked to supply proof of identity and address before making a withdrawal from your account. Credit and Debit card payments undergo a 3D Secure process. To find out more, please click here</p>
                            <p>Withdrawals Withdrawals will be directed to the same source. If your query is not covered by the information contained here, <span v-if="$siteSettings?.data?.social_link?.email"> please email <a :href="`mailto:${$siteSettings?.data?.social_link?.email}`">{{$siteSettings?.data?.social_link?.email}}</a> where staff will be on hand to answer your query</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <QrCodeModal :qrCode="qrCode"/>
    <QrCodeShareModal :qrCode="qrCode"/>
</template>

<script  setup>
import { mapGetters } from 'vuex';
import { ref, computed ,onMounted,inject, getCurrentInstance } from 'vue';
import { getParentPaymentsMethods, onUploadImage, submitDepositAmount, getPaymentGatewayUrl } from '../services/depositPayment';
import WalletInstructions from '../components/WalletInstructions.vue';
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import QrCodeShareModal from '../components/QrCodeShareModal.vue';
import QrCodeModal from '../components/QrCodeModal.vue';
import { useStore } from 'vuex'
const { $t, $errorToast, $successToast, $siteSettings } = getCurrentInstance().proxy;

const store = useStore();

const walletConfig = inject('walletConfig')
// ref
const parentPaymentsList = ref(null);
const paymentDetailsList = ref(null);
const uploadedImage = ref(null);
const manual_utr = ref(null);
const fileRef = ref(undefined);
const loading = ref(false);
// const selectPaymentAccount = ref(null);
const has_edited_utr = ref(0);
const previewImage = ref(null);
const copiedText = ref(null);
const walletLoading = ref(false);
const currentImgLink = ref(null);
const t = ref(6);
const interval = ref(30);
const angle = ref(0);
const intervalCounter = ref(0);
const timerValue = ref(9);
const timer = ref(null);
const utrLoader = ref(false);
const utrerror = ref(false);
const init = ref({
    utr: false,
    transaction_image_url: false
});
const termsAgreed = ref(false);
const utrLimitError = ref(false);
const currentAccount = ref(-1);
const utrMsg = ref({
    langKey: 'enter-utr',
    msg: "Kindly enter UTR Number manually for fast deposit."
});
const tesseract_utr = ref(null);
const isPaymentGateway = ref(null);
const manualEnterUtr = ref(0);
const activeTab = ref(null);
const accountDetails = ref(null);
const paymentProofFileUploadStatus = ref('');
// template refs
const sbtBtn = ref(null);

// computed
const bonusData = computed(() => store.getters?.bonusData);
const depositAmount = computed(() => store.getters?.depositAmount);

const methodIcons = computed(() => {
    let iconObj = {};
    walletConfig?.value?.payment_method?.forEach(element => {
        iconObj[element.method_name] = element.icon
    });
    walletConfig?.value?.bank_list?.forEach(element => {
        iconObj[element.bank_name] = element.icon
    });
    return iconObj
});

const paymentBonus = computed(() => {
    if (!bonusData.value || !Array.isArray(bonusData.value)) {
        return {};
    }

    const paymentBonusData = bonusData.value?.filter(bd => bd.bonusType === 'payment bonus');

    if (paymentBonusData.length === 0) {
        return {};
    }

    return paymentBonusData.reduce((methodBonusMap, bonusElement) => {
        try {
            const methodIds = JSON.parse(bonusElement.methodIds);
            if (Array.isArray(methodIds)) {
                methodIds?.forEach(methodId => {
                    methodBonusMap[methodId] = bonusElement.percentage;
                });
            }
        } catch (error) {
            console.warn('Failed to parse methodIds for payment bonus:', bonusElement.methodIds, error);
        }
        return methodBonusMap;
    }, {});
});

    //methods
        const getSafeTabId = (method, index) => {
            const base = method?.name || `tab-${index}`;
             return 'tab-' + base.toString().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase()
        };
        function downloadQrImg(imageUrl, name) {
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = name;
            link.target = '_blank';
            link.click();
        };
        function copyImgUrl() {
            var input = document.createElement('textarea');
            input.innerHTML = currentImgLink.value;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            $successToast('Successfully copied.');
        };
        function startTimer() {
            utrLoader.value = true;
            angle.value = 0;
            intervalCounter.value = 0;
            timerValue.value = t.value;

            if (timer.value) {
                clearInterval(timer.value);
            }

            timer.value = setInterval(() => {
                intervalCounter.value = intervalCounter.value + 1;
                angle.value = (intervalCounter.value / (t.value * (1000 / interval.value))) * 360;

                timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);

                if (timerValue.value <= 0) {
                    resetTimer();
                    utrLoader.value = false;
                }
            }, interval.value);
        };
        function resetTimer() {
            clearInterval(timer.value);
            utrLoader.value = false;
            angle.value = 0;
            intervalCounter.value = 0;
            timerValue.value = t.value;
        };
        function clearPaymentSlip() {
            previewImage.value = null;
            manual_utr.value = '';
            manual_utr.value = '';
            // file.value = undefined;
            utrLimitError.value = '';
            utrerror.value = '';
            manual_utr.value = '';
            manualEnterUtr.value = 0;
        };
        function copyPaymentData(catagory, accountData) {
            if (!accountData) {
                $errorToast($t('no-data-available-to-copy', 'No Data Available To Copy.'));
                return;
            }
            var input = document.createElement('textarea');
            input.innerHTML = accountData;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            copiedText.value = accountData;
            $successToast(catagory + ' Copied Successfully');
            document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
                el.style.color = '';
            });
            setTimeout(() => {
                copiedText.value = null;
                document.querySelectorAll('.copty_cmn_btn i').forEach(el => {
                    el.style.color = '#0cddff';
                });
            }, 1000);
        };
        function selectPaymentMethodAccount(paymentAccount) {
            accountDetails.value = paymentAccount;
            toggleInit(false)
        };
        async function getParentPaymentMethods(reconnectTry = 0) {
            try {
                let response = await getParentPaymentsMethods(reconnectTry, depositAmount.value);
                if (response?.data) {
                    parentPaymentsList.value = response?.data
                    let nonSocialStartIndex = response?.nonSocialStartIndex;
                    activeTab.value = Object.keys(parentPaymentsList.value)[nonSocialStartIndex]
                    choosePaymentMethod(parentPaymentsList.value[activeTab.value], activeTab.value);
                }
            } catch (error) {
                $errorToast(error)
            }
        };
        function choosePaymentMethod(payment, index) {
            clearPaymentSlip()
            toggleInit(false)
            activeTab.value = index;
            paymentDetailsList.value = payment;
            if (payment?.[0]?.method == 'social') {
                const socialNumber = payment?.[0]?.social_payment_number;
                const socialLink = payment?.[0]?.social_payment_link;
                if (socialNumber?.length && socialLink?.length) {
                    const choice = Math.random() < 0.5 ? 'number' : 'link';
                    if (choice === 'number') {
                        if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                            window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                        } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                            window.open(`https://t.me/${socialNumber}`, 'blank');
                        }
                    } else {
                        window.open(socialLink, 'blank');
                    }
                    return;
                }
                if (socialNumber?.length) {
                    if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                        window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                    } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                        window.open(`https://t.me/${socialNumber}`, 'blank');
                    }
                    return;
                }
                if (socialLink?.length) {
                    window.open(socialLink, 'blank');
                    return;
                }
                $errorToast($t('no-social-payment-number', 'No social payment number available'));
                return;
            };
            if (payment?.[0]?.method == 'payment_gateway') {
                isPaymentGateway.value = true;
                paymentDetailsList.value = payment;
                return
            }
            activeTab.value = index
            // currentPaymentId.value = payment?.[0]?.method
            paymentDetailsList.value = payment
            // AccountS3Url.value = payment?.qrCodeUrl
            accountDetails.value = paymentDetailsList.value?.[0]
            isPaymentGateway.value = false;
        };
        async function goToPaymentGateway() {
            try {
                const response = await getPaymentGatewayUrl(depositAmount.value, paymentDetailsList.value?.[0]?.master_account_id);
                console.log(response)
            } catch (error) {
                $errorToast(error)
            }
        };
        function toggleInit(bool) {
            init.value = {
                utr: bool,
                transaction_image_url: bool
            }
        };
        async function walletDepositSubmitBtn() {
            try {
                termsAgreed.value = true;
                toggleInit(true);
                if(!uploadedImage.value) return ;
                if (accountDetails.value?.method != 'wallet' && (manual_utr.value?.length < 10 || !manual_utr.value)) return;
                await submitDepositAmount({
                    accountDetails: accountDetails.value,
                    uploadedImage: uploadedImage.value,
                    depositAmount: depositAmount.value,
                    manual_utr: manual_utr.value,
                    removeImage: removeImage,
                    has_edited_utr: has_edited_utr.value
                });

            } catch (error) {
                console.log(error);
                $errorToast(error)
            }
        };
        function removeImage() {
            uploadedImage.value = null
            previewImage.value = null
            manual_utr.value = ''
            manualEnterUtr.value = 0
        };
        function sanitizeInput() {
            manual_utr.value = manual_utr.value?.replace(/\D+/g, '');
        };
        async function fileUpdateFunc(event) {
        try {
            paymentProofFileUploadStatus.value = 'Fetching payment proof file';
            const file = event.target.files?.[0];
            // Only proceed if at least one file is selected
            if (!file) {
                return $errorToast($t('no-file-selected','No File selected to upload'))
            }
            const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
            const maxFileSize = 5 * 1024 * 1024; 
            if (!allowedTypes.includes(file.type) || file.size > maxFileSize) {
                $errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                previewImage.value = null;
                fileRef.value.value = null
                return;
            }
            paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';
            previewImage.value = URL.createObjectURL(file)
            let response = await onUploadImage({
                event,
                depositAmount: depositAmount.value,
                startTimer: startTimer,
                resetTimer: resetTimer,
                sbtBtn: sbtBtn.value,
                paymentProofFileUploadStatus
            });
            if (response) {
                if(!response?.manual_utr){
                paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
                }else{
                    paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
                }
                manual_utr.value = response?.manual_utr;
                utrMsg.value = response?.utrMsg;
                uploadedImage.value = response?.uploadedImage;
                previewImage.value = response?.previewImage;
                tesseract_utr.value = response?.tesseract_utr;
                utrLoader.value = false
                if (response.manual_utr) {
                    has_edited_utr.value = 0
                }
            }
            else {
                paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
                // this.previewImage = null
            }
        } catch (error) {
            console.log('error: ', error);
            previewImage.value = null;
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
            $errorToast(error)
        }
        finally{
            setTimeout(() => {
                paymentProofFileUploadStatus.value = '';
            }, 2000);
        }
    };
    function onFilePickerOpen() { 
        window.addEventListener('focus', () => {        
            setTimeout(() => {
                const files = fileRef.value?.files;
                if (files?.length == 0) {
                    $errorToast('File not selected. Check permission or try again!!')
                }
            }, 1000);
        }, { once: true })
    }
// hooks
onMounted(getParentPaymentMethods)
</script>

<style>
.form-bank-wrapper .nav.nav-pills {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
    overflow-y: hidden;
}

.bank-details-tabs-content .tab-content .upi-card-list .upi-payment-content {
    max-height: inherit !important;
    overflow: hidden !important;
}

.qr-img {
    max-height: 230px;
    overflow: hidden;
    max-width: 230px;
}

.qr-img img {
    width: auto;
    max-height: 220px;
}

.code-list .team-list-sec {
    padding: 0;
}

@media screen and (max-width: 1450px) {
    .form-bank-wrapper {
        width: initial;
    }
}

.add-utr-again img {
    width: fit-content;
}
</style>